var _g, _path, _g2, _path2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSingleValidationSubmission = function SvgSingleValidationSubmission(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_999_7788)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_999_7788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 54.4767C47.3961 54.1776 48.0797 54.1753 48.6562 54.4703L75.5213 68.2196C76.973 68.9626 76.973 71.0374 75.5213 71.7804L48.6562 85.5297C48.0797 85.8247 47.3961 85.8224 46.8216 85.5233L20.4081 71.774C18.9727 71.0269 18.9727 68.9731 20.4081 68.226L46.8216 54.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_999_7788",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_999_7788)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2141 12)",
    fill: "url(#paint0_linear_999_7788)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6471 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2141 48)",
    fill: "url(#paint1_linear_999_7788)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2721 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0378 30)",
    fill: "url(#paint2_linear_999_7788)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0959 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_999_7788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4735 67.2151L58.1961 66.7979C58.2957 66.7405 58.9832 63.1156 59.0622 63C59.1385 62.8882 60.0019 57.4174 60.0019 57.4174L68.1554 52.75L68.3155 52.6176C68.3333 52.5301 69.007 52.2967 68.9934 52.2262C68.9798 52.1557 69.2468 52.4932 69.2046 52.4542C69.1624 52.4152 69.1082 52.3952 69.0461 52.3958C68.984 52.3963 68.9158 52.4174 68.8466 52.4574C68.7317 52.5237 68.6215 52.5347 68.5403 52.4878C68.459 52.4409 68.4134 52.3401 68.4134 52.2074L68.4134 50.1649C68.4134 50.0266 68.3658 49.9215 68.2812 49.8726C68.1965 49.8238 68.0817 49.8351 67.962 49.9043L60.8863 53.9894C60.6472 54.1274 60.4533 54.0155 60.4533 53.7394L60.4533 52.7181C60.4533 52.5798 60.4058 52.4747 60.3211 52.4258C60.2364 52.3769 60.1216 52.3883 60.0019 52.4574L57.3485 53.9894C57.2288 54.0585 57.114 54.1797 57.0293 54.3263C56.9447 54.473 56.8971 54.633 56.8971 54.7713L56.8971 66.8865C56.8996 67.0419 56.9506 67.1632 57.041 67.2283C57.1319 67.2939 57.2566 67.2982 57.3922 67.2404C57.4204 67.2284 57.4476 67.22 57.4735 67.2151Z",
    fill: "url(#paint3_linear_999_7788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8464 51.9574L68.8464 49.9149C68.8464 49.644 68.7532 49.4381 68.5874 49.3423C68.4215 49.2465 68.1966 49.2688 67.962 49.4043L60.8864 53.4894L60.8864 52.4681C60.8864 52.1972 60.7932 51.9913 60.6273 51.8955C60.4615 51.7997 60.2365 51.822 60.0019 51.9574L57.3486 53.4894C57.114 53.6248 56.889 53.8623 56.7232 54.1496C56.5573 54.4369 56.4641 54.7504 56.4641 55.0213L56.4641 67.1404C56.4674 67.4166 56.5574 67.6321 56.7175 67.7475C56.8776 67.8628 57.0971 67.8704 57.3359 67.7687C57.5747 67.667 57.8168 67.4629 58.018 67.1938C58.2191 66.9246 58.3657 66.6084 58.4311 66.303L59.818 57.9081C59.8711 57.6646 59.9828 57.4131 60.136 57.1915C60.2893 56.9699 60.4758 56.7902 60.6676 56.6795L68.8464 51.9574ZM68.8464 51.9574C68.982 51.8791 69.1158 51.8378 69.2374 51.8367C69.359 51.8357 69.4653 51.8748 69.5479 51.9512C69.6305 52.0276 69.6874 52.1392 69.714 52.2774C69.7406 52.4155 69.7363 52.5765 69.7014 52.7479L68.4042 60.6458C68.354 60.8923 68.243 61.1487 68.0884 61.3752C67.9338 61.6016 67.7442 61.7854 67.5492 61.8979L57.4647 67.7202",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0976 58.3404L61.7709 60.6382L63.0976 61.4042",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7509 56.8085L67.0775 57.5744L65.7509 59.8723",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_999_7788",
    x: 3.33154,
    y: 38.2507,
    width: 89.2786,
    height: 63.4987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.545098 0 0 0 0 0.290196 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_999_7788"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_999_7788",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_999_7788",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_999_7788",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_999_7788",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_999_7788",
    x1: 69.2981,
    y1: 60.3394,
    x2: 57.1558,
    y2: 53.7717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_7788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_999_7788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 53 51)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSingleValidationSubmission);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "single_validation_submission.e1850ec38d5d152c7fbb84c8c18ad443.svg";